import * as React from "react";
const SvgAboutFill = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M5 3a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2h1l.01 4 4.997-4H19a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2zm7 2a1 1 0 0 1 1 1v6a1 1 0 1 1-2 0V6a1 1 0 0 1 1-1m1 10a1 1 0 1 1-2 0 1 1 0 0 1 2 0", clipRule: "evenodd" }));
export default SvgAboutFill;
